// extracted by css-extract-rspack-plugin
export default {"banner":"UpgradeBanner-module__banner___nrweT"};